import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconStory = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M15.0944 2.63362C15.4849 2.2431 16.1181 2.2431 16.5086 2.63362L19.337 5.46205C19.7275 5.85257 19.7275 6.48574 19.337 6.87626L9.53036 16.6829C9.38664 16.8266 9.20253 16.9232 9.00257 16.9596L4.12133 17.8493L5.01104 12.9681C5.04748 12.7681 5.144 12.584 5.28772 12.4403L15.0944 2.63362Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  )
}

export default IconStory
